import { AxiosResponse } from 'axios';

import { UsageApiSlug } from '@shared/types/common/eventTracking';
import { $httpCommonApi, useMutation, UseMutationOptions } from '@shared/utils/http-client';

import { UsageDTO, UsagePayload } from './usageApi.types';

// One endpoint per tracked area, addressed by slug so the caller cannot post to an unrelated path.
// The empty slug is accepted for callers whose area is only known at runtime: useEventTracking must
// call this unconditionally, and it never fires without a slug.
export const useUsageMutation = (apiSlug: UsageApiSlug | '', opts?: UseMutationOptions<UsagePayload, undefined>) =>
  useMutation({
    // Overrides the query client's global mutation onError, which alerts the user. A usage post is
    // invisible telemetry: a failure — server error, or the request blocked by the browser or an
    // extension — must never surface. Callers observe failures through their own mutate callbacks.
    onError: () => undefined,
    ...opts,
    mutationFn: async (data) =>
      (await $httpCommonApi.post<UsageDTO, AxiosResponse<undefined>>(`/usage/${apiSlug}`, data.body)).data,
  });
